<template lang="pug">
  BSteps.team-builder-steps(v-model="activeStep" :animated="false")
    BStepItem(
      v-for="step in steps"
      :key="step.label"
      :label="step.label"
      :icon="isCompletedStep(step.number) ? 'check-bold' : step.icon"
    )
    // DO NOT NEST UNDER BStepItem BECAUSE WILL MOUNT 'STEPS' TIMES
    WtTile(parent :col="12")
      WtTile(child :col="12")
        keep-alive
          TeamBuilderDefine(
            v-if="activeStep === 0 || activeStep === 2"
            :preview-mode="activeStep === 2"
            :form-data="formData"
            @disableNext="updateDisableNext(0, $event)"
            :setSelectedOrganizationId="setSelectedOrganizationId"
            :registrationBuilder="registrationBuilder"
            :registrationData="registrationData"
            :organization="organization"
          )
          TeamBuilderAddMembers(
            v-if="activeStep === 1"
            :form-data="formData"
            @disableNext="updateDisableNext(1, $event)"
            :selectedOrganizationId="selectedOrganizationId"
            :registrationBuilder="registrationBuilder"
            :registrationData="registrationData"
          )
        .spacer-for-navigation
    template(
      slot="navigation"
      slot-scope="{previous, next}"
    )
      TeamBuilderControls(
        :previous="previous"
        :next="next"
        :disable-next="disableNext[activeStep%2]"
        :active-step="activeStep"
        :show-cancel="activeStep === 0"
        :last-step="activeStep === 2"
        @submit="submitTeam"
        :registrationBuilder="registrationBuilder"
        :dismissModal="dismissModal"
      )
</template>

<script>
import { mapActions } from "vuex";
import WtTile from "@@/WtTile/WtTile";
import TeamBuilderDefine from "@@/TeamBuilder/TeamBuilderDefine";
import TeamBuilderAddMembers from "@@/TeamBuilder/TeamBuilderAddMembers";
import TeamBuilderControls from "@@/TeamBuilder/TeamBuilderControls";
import analyticsTrackingMixin from "@/mixins/analyticsTrackingMixin";

export default {
  name: "TeamBuilderSteps",

  components: {
    WtTile,
    TeamBuilderDefine,
    TeamBuilderAddMembers,
    TeamBuilderControls
  },

  mixins: [analyticsTrackingMixin],

  props: {
    registrationBuilder: {
      type: Boolean,
      default: false
    },
    registrationData: {
      type: Object,
      default: () => {}
    },
    dismissModal: {
      type: Function,
      default: () => {}
    },
    organization: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      activeStep: 0,
      disableNext: [true, true],
      steps: [
        {
          number: 0,
          label: "STEP 1: DEFINE",
          icon: "settings"
        },
        {
          number: 1,
          label: "STEP 2: INVITE",
          icon: "account-multiple-plus"
        },
        {
          number: 2,
          label: "STEP 3: REVIEW",
          icon: "flag-checkered"
        }
      ],
      formData: new FormData(),
      selectedOrganizationId: 0
    };
  },

  watch: {
    activeStep(newStep) {
      this.trackTeamBuilderStep(newStep);
    }
  },

  mounted() {
    this.emptyStagedMembers();
    this.trackTeamBuilderStep(this.activeStep);
  },

  methods: {
    ...mapActions("teams", ["createTeam"]),
    ...mapActions("registration", ["createTeamAfterSignIn"]),
    // TODO refactor to teamBuilder
    ...mapActions("challengeBuilder", ["emptyStagedMembers"]),

    async submitTeam() {
      if (this.registrationBuilder) {
        this.createTeamAfterSignIn({
          formData: this.formData
        });
        this.dismissModal();
        return;
      }
      const response = await this.createTeam(this.formData);
      this.$router.push({
        name: "Team",
        params: { teamId: response.data.data.teamNameURL }
      });
    },

    isCompletedStep(stepNumber) {
      return stepNumber < this.activeStep;
    },

    updateDisableNext(stepIndex, value) {
      this.$set(this.disableNext, stepIndex, value);
    },

    setSelectedOrganizationId(id) {
      this.selectedOrganizationId = id;
    },

    trackTeamBuilderStep(stepNumber) {
      const stepNames = [
        "team_builder_define",
        "team_builder_invite",
        "team_builder_review"
      ];
      this.trackFeatureView("team_builder_admin", stepNames[stepNumber]);
    }
  }
};
</script>

<style lang="sass">
.team-builder-steps
  .steps
    margin-bottom: 0 !important
    .step-items
      width: 100% !important
  .step-content
    .spacer-for-navigation
      margin-top: 2rem
      height: 3rem
</style>
